<template>
  <div ref="housesDetail" class="detail houses-detail">
    <div class="detail-center">
      <!-- 头部 -->
      <header>
        <div style="display: flex; align-items: center">
          <!-- <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.back()" /> -->
          <h2 class="title">房源/出租详情</h2>
        </div>
        <HouseDetailsHeader
          ref="DetailsHeaderRef"
          :aManager="AManager"
          :controlJurisdiction="controlJurisdiction"
          :houseId="houseId"
          :housesDatas="HousesDatas"
          :isRentoutSell="'rentOut'"
          :rentSaleType="rentSaleType"
          :uid="uid"
          @getFollowUp="getFollowUp"
          @getHouseDetails="getHouseDetails"
          @housesDetailRef="() => housesDetailRef()"
          @isHouseDetailsHeader="isHouseDetailsHeader"
          @loading="fatherLoading"
          @upStatus="upStatus"
        ></HouseDetailsHeader>
      </header>
      <!--  切换标题-->
      <aside>
        <div class="card-container">
          <a-tabs :forceRender="true" default-active-key="1" type="card" @change="getTabs">
            <a-tab-pane key="1" tab="基本信息">
              <div class="basicInfor">
                <HouseSwiperImg
                  :housesData="HousesData"
                  :skImgList="skImgList"
                  :uid="uid"
                  @EditImg="EditImg"
                  @addImg="addImg"
                  @previewSwiperImg="previewSwiperImg"
                  @showDownloadFile="showDownloadFile"
                />
                <HouseDetails
                  :aManager="AManager"
                  :controlJurisdiction="controlJurisdiction"
                  :housesData="HousesData"
                  :industryCategoryJsonName="industryCategoryJsonName"
                  :industryCategoryVoList="industryCategoryVoList"
                  :industrySubclassJsonName="industrySubclassJsonName"
                  :newFollowUpMsg="newFollowUpMsg"
                  :rentSaleType="rentSaleType"
                  :uid="uid"
                  @getHouseDetails="getHouseDetails"
                  @showuploadmoadl="showuploadmoadl"
                  @viewEntrust="viewEntrust"
                ></HouseDetails>
              </div>

              <div class="inforCenter">
                <HouseOtherInfo :housesDatas="HousesDatas"></HouseOtherInfo>
                <a-divider />
                <HouseSuperiority :HousesDatas="HousesDatas"></HouseSuperiority>
                <a-divider />
                <div class="bot-detail">
                  <a-row>
                    <a-col :span="12">
                      <div style="display: flex; justify-content: space-between; width: 100%">
                        <p>动态</p>
                        <div class="" style="margin-top: 20px">
                          <span
                            v-if="HousesData.accendantId === uid || controlJurisdiction"
                            class="iconfont icon-bianji1"
                            style="font-size: 14px; color: var(--ThemeColor)"
                          ></span>
                          <span v-if="HousesData.accendantId === uid || controlJurisdiction" style="cursor: pointer" @click="followFn">写跟进</span>
                          <!-- v-hasPermi="['houses:followUpRecord:add']" -->

                          <span v-if="HousesData.accendantId === uid || controlJurisdiction" style="cursor: pointer" @click="Recording()">
                            录面访
                          </span>
                          <!-- v-hasPermi="['houses:interviewRecord:add']" -->
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="12">
                      <div style="display: flex; justify-content: space-between; width: 100%">
                        <p style="margin-left: 6px">相关人员</p>
                        <div v-if="controlJurisdiction" style="margin-top: 20px">
                          <!-- 添加AB店长权限 -->
                          <span class="iconfont icon-bianji1" style="font-size: 14px; color: var(--ThemeColor)"></span>
                          <span style="cursor: pointer" @click="showedit('编辑人员')">编辑人员</span>
                        </div>
                        <div v-else style="margin-top: 20px">
                          <span
                            v-hasPermi="['houses:relatedPersonnelInfo:edit']"
                            class="iconfont icon-bianji1"
                            style="font-size: 14px; color: var(--ThemeColor)"
                          ></span>
                          <span v-hasPermi="['houses:relatedPersonnelInfo:edit']" style="cursor: pointer" @click="showedit('编辑人员')">
                            编辑人员
                          </span>
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                  <div class="bot-detail-bot">
                    <div class="bot-detail-left">
                      <HouseDynamicState
                        :current="current"
                        :curtId="curtId"
                        :recordlist="recordlist"
                        :recordlistSpinning="recordlistSpinning"
                        :recordpage="recordpage"
                        @onChange="onChange"
                        @upStatus="upStatus"
                      ></HouseDynamicState>
                    </div>
                    <div class="bot-detail-right">
                      <HouseCorrelationPerson
                        :editbtnshow="editbtnshow"
                        :relaInfotabledata="relaInfotabledata"
                        @Editor="Editor"
                      ></HouseCorrelationPerson>
                    </div>
                  </div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane v-if="isHistory" key="2" tab="成交历史">
              <HouseTransactionHistory v-if="tabindex == 2" :houseId="houseId" :rentSaleType="rentSaleType"></HouseTransactionHistory>
            </a-tab-pane>
          </a-tabs>
        </div>
      </aside>
    </div>
    <!--新增图片-->
    <a-modal v-model="EditImgShow" :title="optTitleSk" width="800px" @ok="handleEditSkImg">
      <investigation-cmp :fileList="HousesData.houseInfoImgVo" :type="optType" @submitSkImg="submitSkImgHandele"></investigation-cmp>
    </a-modal>

    <!--下载图片弹出-->
    <download-sk-cmp
      v-if="showDownLoad"
      :edit-download-img-show="editDownloadImgShow"
      :fileList="houseInfoImgVo"
      :rentSaleType="this.rentSaleType"
      @closeModal="hideDownloadFile"
    ></download-sk-cmp>

    <!-- 录面访start -->
    <HouseRecordInterview ref="HouseRecordInterview" :houseId="houseId" :rentSaleType="rentSaleType" @upStatus="upStatus"></HouseRecordInterview>
    <!-- 录面访end -->
    <!--loading-->
    <div v-show="loading" class="topcenter">
      <LoadingModel></LoadingModel>
    </div>
    <div v-if="showSwiperImg" class="preview_cover" @click="closeSwiperImg">
      <img v-if="previewType === 'img'" :src="swiperImgUrl" alt="preview" class="preview_img" title="点击图片任意位置退出预览" />
      <video v-if="previewType === 'video'" :src="swiperImgUrl" class="preview_video" controls="controls" title="点击视频任意位置退出预览">
        该内容不支持播放
      </video>
    </div>
  </div>
</template>

<script>
// 上传
// 引入图标
import './assets/font/iconfont.css';
import houseApi from '@/api/system/houses/house.js';
import storage from 'store';
import LoadingModel from '@/components/Loading';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import InvestigationCmp from '@/views/houses/details/detail/investigation';
import DownloadSkCmp from '@/views/houses/details/detail/download';
import { treeSelectMixin } from '@/mixin/treeSelect';
import HouseTransactionHistory from './components/houseTransactionHistory.components.vue'; // 成交历史组件
import HouseDetailsHeader from './components/houseDetailsHeader.components.vue'; // 房源详情头部
import { mapGetters } from 'vuex';
import HouseOtherInfo from './components/houseOtherInfo.components.vue'; // 其他信息
import HouseSuperiority from './components/houseSuperiority.components.vue';
import HouseRecordInterview from './components/houseRecordInterview.coponents';
import HouseCorrelationPerson from './components/houseCorrelationPerson.components.vue';
import HouseDynamicState from './components/houseDynamicState.components.vue';
import HouseDetails from './components/houseDetails.components.vue';
import HouseSwiperImg from './components/houseSwiperImg.components.vue';
// import { defineAsyncComponent } from 'vue';

let route;
export default {
  name: 'HousesDetails',
  components: {
    LoadingModel,
    InvestigationCmp,
    DownloadSkCmp,
    // 成交历史
    HouseTransactionHistory,
    HouseDetailsHeader,
    HouseDynamicState,
    HouseSuperiority,
    HouseCorrelationPerson,
    HouseRecordInterview,
    HouseDetails,
    HouseSwiperImg,
    // HouseSwiperImg: defineAsyncComponent(() => import('./components/houseSwiperImg.components.vue')),
    HouseOtherInfo
  },
  mixins: [treeSelectMixin],

  data() {
    const userInfo = this.$getters.userInfo;
    const isHistory = userInfo.data.permissions.includes('houses:houseInfo:makeHistory') || userInfo.data.permissions.includes('*:*:*');
    // console.log(userInfo,'userInfo')
    return {
      userInfo,
      rentSaleType: '1', // 出租
      isHistory,
      newFollowUpMsg: {}, // 最新跟进信息
      isuser: true,
      isKeyuser: true,
      recordlistSpinning: false,
      headers: {
        authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      },

      showClaim: false,

      optType: '1',
      optTitleSk: '新增实勘图',

      showDownLoad: false,

      param_identity: {
        id: undefined, //	房源ID		true
        identity: undefined, //	标识（1:五，2:独，3:优，4:钥匙）		true
        identityStr: undefined //	标识状态 字典表类型：sys_yes_no
      },

      investigationIdArr: [], // 实勘图ids
      buttonWidth: 70,
      // 分页
      current: 1,
      // 加载
      loading: false,
      // 编辑图片
      EditImgShow: false,
      // 下载图片
      editDownloadImgShow: false,
      imageUrl: '',
      imageUrlAttorney: '',
      imageUrlCertificate: '',
      loadingAttorney: false,
      loadingCertificate: false,
      value: '',
      num: 0,
      num1: 0,
      // 轮播
      swiperOption: {
        autoplay: true,
        speed: 3000,
        loop: true,
        slidesPerView: 3,
        watchSlidesVisibility: true, // 防止不可点击
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      curtId: 0,
      IconStatus: {
        id: 1,
        identity: '1',
        identityStr: '1'
      },
      imgPrefix: process.env.VUE_APP_OSS_URL,
      // 轮播图图片
      AddImg: [
        { id: 1, imgSrc: require('../detail/assets/img/detail-img.png') },
        { id: 1, imgSrc: require('../detail/assets/img/detail-img.png') }
      ],

      // 房源详细信息
      HousesData: {},
      tabindex: 1,
      AManager: false, // A店长权限 详情无效转有效 有效转无效 只有A店长才有权限相互转 其他普通经纪人只能上下架转换
      controlJurisdiction: false, // AB店长权限 true用户该房源所有权限 反之使用原本权限逻辑
      recordlist: [],
      recordpage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        current: 1
      },
      index_a: 0, // 分页用全局分页参数
      editbtnshow: false, // 编辑按钮控制显示
      RelaInfoPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }, // 相关人员查询分页参数
      RelaInfotabledata: [], // 相关人员数据
      relaInfotabledata: [], // 相关人员数据
      HousesDatas: {},
      moreModalvb: false,
      isDetailsHeader: false,
      houseId: '', // 房源id
      addImgData: {
        houseId: undefined, //	id不能为空		true
        identity: undefined, //	请求类型标识（1：新增实勘:2：编辑图片）		true
        investigationImgs: {
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        } // 实勘图片IDs		true
      },
      botList: [
        { id: 1, title: '全部', status: true },
        { id: 2, title: '跟进', status: false },
        { id: 3, title: '面访', status: false },
        { id: 4, title: '钥匙', status: false },
        { id: 5, title: '查看', status: false },
        { id: 6, title: '其他', status: false },
        { id: 7, title: '被带看', status: false },
        { id: 8, title: '意向', status: false }
      ],
      imgOssIdObj: {}, // 实勘图ossId对象
      skImgList: [], // 实勘图片集(用于轮播展示)
      skEditImgList: [], // 实勘图片集(用于编辑实盘展示)
      houseInfoImgVo: {}, // 实勘图对象（下载）
      uid: undefined,
      position: undefined, // 0.普通员工，1.门店，2.团队或小组（string）
      industryCategoryJsonName: [], // 行业大类名称
      industryCategoryVoList: [],
      industrySubclassJsonName: [], // 行业小类名称
      industryCategoryJsonNameStr: '', // 行业大类名称
      industrySubclassJsonNameStr: '', // 行业小类名称
      showSwiperImg: false,
      swiperImgUrl: '',
      previewType: 'img', // 预览类型
      countReq: 0 // 请求次数
    };
  },

  mounted() {
    if (!this.userInfo.data.roles.includes('ZJL')) {
      this.$refs.DetailsHeaderRef.goFollowUpBtn(); // 防止查看后刷新
    }
  },
  created() {
    this.init();
  },
  activated() {
    const storage = sessionStorage.getItem('history');
    // console.log(storage,'storage')
    let data = {};
    if (storage) {
      data = JSON.parse(storage);
      if (data.fromPage === 'list') {
        // console.log('77777')
        this.countReq++;
        this.init();
      }
    }
    this.route = this.$route;
  },
  deactivated() {
    this.countReq = 0;
    sessionStorage.removeItem('history');
  },
  methods: {
    init() {
      if (this.countReq > 1) {
        return;
      }
      console.log(this.$getters.userInfo, ' this.$getters.userInfo');
      this.uid = this.$getters.userInfo.userId;
      this.position = this.$getters.userInfo.position;

      this.houseId = this.$route.query.id;
      this.getHouseDetails();
      this.upStatus(0);
      this.getRelaInfoListFn(); // 相关人员查询
      this.getFollowUp(); // 第一条跟进信息
      this.countReq = 0;
    },
    isHouseDetailsHeader(value) {
      this.isDetailsHeader = value;
    },
    // 修改loading
    fatherLoading(value) {
      this.loading = value;
    },
    // 让a-modal上传委托挂载到当前父节点
    housesDetailRef() {
      this.$refs.DetailsHeaderRef.refHtml = this.$refs.housesDetail;
    },
    previewSwiperImg(parms) {
      this.showSwiperImg = parms.showSwiperImg;
      this.swiperImgUrl = parms.swiperImgUrl;
      this.previewType = parms.previewType; // 预览类型
    },
    closeSwiperImg() {
      this.showSwiperImg = false;
      this.swiperImgUrl = '';
    },
    // 点击table切换
    getTabs(index) {
      // 请求成交历史历史
      this.tabindex = index;
    },

    // 获取相关人员列表
    getRelaInfoListFn() {
      const params = {
        pageNum: this.RelaInfoPage.pageNum,
        pageSize: this.RelaInfoPage.pageSize,
        resourceId: this.houseId,
        resourceType: 1,
        rentSaleType: this.rentSaleType
      };
      houseApi
        .getRelaInfoList({
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            this.RelaInfoPage.total = res.data.total;
            this.RelaInfotabledata = res.data.records;
            this.relaInfotabledata = res.data.records;
          }
        });
    },
    judgePermission() {
      const info = (this.$store.state.user.info && this.$store.state.user.info.data.leaders) || [];
      const jurisdiction = info.map((item) => item.deptId).includes(this.HousesDatas.accendantStoreId);
      const maintainerId = this.RelaInfotabledata.filter((item) => item.relatedPersonnelType == '1').map((item) => item.relatedDeptId);
      const maintainerIds = maintainerId.map((mainItem) => [...new Set(info.map((item) => item.deptId))].includes(mainItem));
      const xgry = maintainerIds.includes(true);
      this.controlJurisdiction = jurisdiction || xgry;
      this.AManager = jurisdiction || this.getAdmin;
      console.log('A店长=>' + jurisdiction, 'B店长=>' + xgry, this.AManager);
    },
    // 编辑图片
    addImg() {
      this.EditImgShow = true;
      this.optType = '1';
      this.optTitleSk = '新增实勘图';
    },
    EditImg() {
      this.EditImgShow = true;
      this.optType = '2';
      this.optTitleSk = '编辑实勘图';
    },
    // 写跟进
    followFn() {
      this.$refs.DetailsHeaderRef.followShow = true;
      this.$refs.DetailsHeaderRef.getYSteamList();
    },
    closeModalFollowUp() {
      this.$refs.DetailsHeaderRef.followShow = false;
      this.upStatus(1);
      this.getFollowUp(); // 第一条跟进信息
    },

    // 录面访
    Recording() {
      this.$refs.HouseRecordInterview.recordShow = true;
    },
    showedit() {
      this.editbtnshow = !this.editbtnshow;
    },

    // 轮播按钮
    leftBtn() {
      const img = document.getElementById('imgbox');
      this.num -= 200;
      img.style.marginLeft = this.num + 'px';
    },
    rightBtn() {
      const img = document.getElementById('imgbox2');
      this.num1 -= 200;
      img.style.marginRight = this.num + 'px';
    },
    // 获取房源的详细信息
    getHouseDetails() {
      houseApi.houseDetails(this.houseId).then((res) => {
        if (res.code === 200) {
          this.HousesDatas = res.data;
          console.log('其他信息列表传递', this.HousesDatas);
          this.HousesData = res.data;
          console.log(res.data, 'res.data');
          console.log(this.HousesData, 'this.HousesData');
          this.judgePermission();
          // 行业大类名称
          const industryCategoryJsonName = this.HousesData.industryCategoryJsonName;
          this.industryCategoryJsonName = industryCategoryJsonName ? JSON.parse(industryCategoryJsonName) : [];
          this.industryCategoryJsonNameStr = industryCategoryJsonName
            ? industryCategoryJsonName.replace(/\[/g, '').replace(/\]/g, '').replace(/\"/g, '')
            : ''; // 行业大类名称
          this.industryCategoryVoList = this.HousesData.industryCategoryVoList;
          // 行业小类名称
          const industrySubclassJsonName = this.HousesData.industrySubclassJsonName;
          this.industrySubclassJsonName = industrySubclassJsonName ? JSON.parse(industrySubclassJsonName) : [];
          this.industrySubclassJsonNameStr = industrySubclassJsonName
            ? industrySubclassJsonName.replace(/\[/g, '').replace(/\]/g, '').replace(/\"/g, '')
            : '';

          const imgVo = this.HousesData.houseInfoImgVo;
          this.houseInfoImgVo = imgVo;
          this.rebuildSkImgList(imgVo);
          this.initSkParams();
          this.RelaInfoPage.pageNum = 1;
          this.getRelaInfoListFn();

          // 非私盘可认领 （1私盘 2单店 3 公司）
          this.showClaim = this.HousesData.dishType !== '1';
        }
      });
    },
    rebuildSkImgList(imgVo) {
      const interiorList_ = imgVo.interiorList;
      const planeList_ = imgVo.planeList;
      const rimList_ = imgVo.rimList;
      const thisShopList_ = imgVo.thisShopList;
      const videoList_ = imgVo.videoList;
      let skImgList_ = [];
      skImgList_ = this.getSkList(videoList_, skImgList_);
      skImgList_ = this.getSkList(thisShopList_, skImgList_);
      skImgList_ = this.getSkList(interiorList_, skImgList_);
      skImgList_ = this.getSkList(planeList_, skImgList_);
      skImgList_ = this.getSkList(rimList_, skImgList_);
      this.skImgList = skImgList_;
    },
    getSkList(list, resList) {
      if (list != null && list.length > 0) {
        for (const item of list) {
          console.log(item);
          resList.push(item);
        }
      }
      return resList;
    },

    onChangerela(current) {
      this.RelaInfoPage.pageNum = current;
      this.getRelaInfoListFn();
    },
    onChange(current) {
      this.current = current;
      this.recordpage.pageNum = current;
      this.upStatus(this.index_a);
    },
    // 查询房源动态记录列表
    upStatus(index) {
      this.recordlistSpinning = true;
      this.recordlist = [];
      this.index_a = index;
      this.recordpage.current = 1;
      const params = {
        pageNum: this.recordpage.pageNum,
        pageSize: this.recordpage.pageSize
      };

      if (this.botList[index].id === 1) {
        // 全部
      }
      if (this.botList[index].id === 2) {
        // 跟进
        params.recordType = 2;
      }
      if (this.botList[index].id === 3) {
        // 面访
        params.recordType = 1;
      }
      if (this.botList[index].id === 4) {
        params.recordType = 5;
        // 钥匙
      }
      if (this.botList[index].id === 5) {
        params.recordType = 3;
        // 查看
      }
      if (this.botList[index].id === 6) {
        params.recordType = 6;
        // 其他
      }
      if (this.botList[index].id === 7) {
        params.recordType = 4;
        // 其他
      }
      if (this.botList[index].id === 8) {
        params.recordType = 8;
        // 意向
      }
      params.houseId = this.houseId;
      params.rentSaleType = this.rentSaleType;
      this.curtId = index;
      houseApi
        .getInterview({
          ...params
        })
        .then((res) => {
          this.recordlistSpinning = false;
          if (res.code === 200) {
            this.recordlist = res.data.records;
            this.recordpage.total = res.data.total;
            // this.recordpage.current=res.data.current
            this.loading = false;
          }
        });
    },
    // 编辑人员
    Editor(item, e) {
      this.$refs.DetailsHeaderRef.Editor(item, e);
    },

    // 弹出上传钥匙弹出框
    showuploadmoadl(index, opt) {
      this.$refs.DetailsHeaderRef.showuploadmoadl(index, opt);
    },

    // 相关人员编辑 // 转维护人
    editStaff() {
      this.$refs.DetailsHeaderRef.editStaff();
    },
    editIdentityHandle(type, val) {
      // editIdentityHandle('du',HousesData.identityAlone)
      val = val === 'Y' ? 'N' : 'Y';
      this.loading = true;

      this.param_identity = {
        id: this.houseId, //	房源ID		true
        identity: type, //	标识（1:五，2:独，3:优，4:钥匙）		true
        identityStr: val //	标识状态 字典表类型：sys_yes_no
      };
      const type_ = parseInt(type);
      houseApi.editIdentity(this.param_identity).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          if (type_ === 1) {
            this.HousesData.identityFive = val;
          } else if (type_ === 2) {
            this.HousesData.identityAlone = val;
          } else if (type_ === 3) {
            this.HousesData.identityExcellent = val;
          } else if (type_ === 4) {
            this.HousesData.identityKey = val;
          }
          this.$message.success('操作成功');
          this.getHouseDetails();
          //  this.$forceUpdate()
        } else {
          this.$message.error('操作失败');
          this.loading = false;
        }
      });
    },
    // 实勘图处理
    handleEditSkImg() {
      //  this.initSkParams();
      this.addImgData.identity = this.optType; //	请求类型标识（1：新增实勘:2：编辑图片）		true
      houseApi
        .investigation({
          ...this.addImgData
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功');
            this.EditImgShow = false;
            this.initSkParams();
            this.getHouseDetails();
            this.getRelaInfoListFn();
          }
        });
    },
    initSkParams() {
      this.addImgData = {
        houseId: this.houseId, //	id不能为空
        identity: this.optType, //	请求类型标识（1：新增实勘:2：编辑图片）		true
        investigationImgs: {
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        } // 实勘图片IDs		true
      };
      const imgVo = this.HousesData.houseInfoImgVo;
      const interiorList_ = imgVo.interiorList;
      const planeList_ = imgVo.planeList;
      const rimList_ = imgVo.rimList;
      const thisShopList_ = imgVo.thisShopList;
      const videoList_ = imgVo.videoList;

      // 1视频 2本铺 3内部 4平面 5周边
      this.addImgData.investigationImgs = {
        1: this.getListOssId(videoList_),
        2: this.getListOssId(thisShopList_),
        3: this.getListOssId(interiorList_),
        4: this.getListOssId(planeList_),
        5: this.getListOssId(rimList_)
      };
    },
    getListOssId(list) {
      let ossId = '';
      const ossIdArr = [];
      if (list != null && list.length > 0) {
        for (const item of list) {
          ossIdArr.push(item.ossId);
        }
        ossId = ossIdArr.join(',');
      }
      return ossId;
    },
    submitSkImgHandele(obj) {
      this.imgOssIdObj = obj;

      this.addImgData.houseId = this.houseId;
      this.addImgData.identity = this.optType;
      this.addImgData.investigationImgs = obj;
    },
    // 下载图片显示页面
    showDownloadFile() {
      this.editDownloadImgShow = true;
      this.houseInfoImgVo = this.HousesData.houseInfoImgVo;
      this.showDownLoad = true;
    },
    hideDownloadFile() {
      this.editDownloadImgShow = false;
    },
    // 下载实勘
    downloadFile() {
      this.loading = true;
      const idArr = this.getDownloadAllOssId(this.addImgData.investigationImgs);
      for (const ossId_ of idArr) {
        const ossIdInt = parseInt(ossId_);
        houseApi.downloadOssId_house(ossIdInt).then((res) => {
          if (res.code === 200) {
            this.$message.success('下载成功');
          }
        });
      }
      this.loading = false;
    },
    getDownloadAllOssId(obj) {
      let idArr = [];
      let idStr = '';
      for (const k in obj) {
        if (obj[k] != null && obj[k] !== '' && typeof obj[k] !== 'undefined') {
          idStr += obj[k].split(',') + ',';
        }
      }
      if (idStr != null && idStr.length > 1) {
        idStr = idStr.substring(0, idStr.length - 1);
      }
      idArr = idStr.split(',');
      idArr = idArr.map(Number);
      return idArr;
    },

    // 查看委托
    viewEntrust() {
      console.log('点击查看');
      this.$refs.DetailsHeaderRef.viewEntrust();
    },

    // 修改房源状态
    getEditHouseInfoStatus(lastStatus) {
      const parmars = {};
      parmars.lastStatus = lastStatus;
      parmars.resourceId = this.houseId;
      parmars.rentSaleType = this.rentSaleType;
      parmars.resourceType = 1;
      houseApi.editHouseInfoStatus(parmars).then((res) => {
        if (res.code === 200) {
          this.upStatus(0);
          this.getHouseDetails();
          if (lastStatus === 1) {
            // this.$message.success('转为有效成功')
            this.$message.success('上架成功');
            return;
          }
          if (lastStatus === 3) {
            this.$message.success('房源设置为自行成交成功');
            return;
          }
          if (lastStatus === 4) {
            this.$message.success('房源设置为无效成功');
            return;
          }
          if (lastStatus === 5) {
            this.$message.success('房源设置为无效成功');
          }
          if (lastStatus === 6) {
            this.$message.success('下架成功');
          }
        }
      });
    },
    // 获取最新一条跟进记录
    getFollowUp() {
      const params = {
        pageNum: 1,
        pageSize: 1,
        recordType: 2,
        rentSaleType: this.rentSaleType,
        houseId: this.houseId
      };
      houseApi
        .getInterview({
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.records[0] && res.data.records[0].length !== 0) {
              this.newFollowUpMsg = res.data.records[0];
            }
          }
        });
    }
  },
  computed: {
    ...mapGetters(['isfollowUpObj']),
    // 拥有超级权限 ，
    getAdmin() {
      const arr = ['ZJL'];
      const loginRole = this.$getters.userInfo.data.roles;
      let status = false;
      loginRole.forEach((el) => {
        if (arr.includes(el)) {
          status = true;
        }
      });
      return status;
    }
  },
  watch: {
    isfollowUpObj: {
      handler(valObj) {
        if (valObj && valObj.isFollowUp === 'N') {
          console.log(valObj, 'watch**********');
          if (this.isDetailsHeader) {
            this.followFn();
          }
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler(val) {
        // console.log(val, '93893')
        if (this.$route.name === this.route.name) {
          // console.log(val, route,this.activeKey, '22', '0000999990000')
          // console.log(this.fromPageName,'54444',this.countReq)
          this.countReq++;
          // this.init()
        }
      },
      deep: true
    }
  },

  filters: {
    fiflterYF(val) {
      if (!val) return;
      return val.replace('Y', '押').replace('F', '付');
    },
    filterDict(val, opts) {
      if (!val) return;
      for (const d of opts) {
        if (d.dictValue == val) {
          return d.dictLabel;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn_svg {
  width: 24px;
  height: auto;
}

.preview_cover {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  cursor: pointer;
}

.preview_img {
  width: 90%;
  height: 90%;
  object-fit: contain;
  margin: 2%;
  cursor: pointer;
  border-radius: 10px;
  -wekit-border-radius: 10px;
}

.preview_video {
  width: 90vw;
  height: 90vh;
  margin: 1vh 5vw auto 5vw;
  cursor: pointer;
  border-radius: 10px;
  -wekit-border-radius: 10px;
}

.downLoad {
  cursor: pointer;
  text-align: right;
  color: var(--ThemeColor);
}

.lunbo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.img_titlePic {
  background: #f2f2f2;
  width: 100%;
  height: 100%;
}

.unclickColor {
  color: gray !important;
}

.unclickBgc {
  background-color: gray !important;
}

.detaill-img： {
  width: 30px;
  height: 30px;
}

.detail {
  width: 100%;
  padding: 20px;
  background-color: white;

  .detail-center {
    // width: 95%;
    margin: 0 auto;

    header {
      height: 66px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .title {
        font-size: 20px;
        font-weight: 700;
        color: #222222;
        margin-bottom: 0px;
      }
    }

    .header {
      height: 80px;
      display: flex;
      align-items: center;

      & > p {
        margin-bottom: 0;
        font-size: 14px;
        font-weight: bold;
        color: black;
      }

      & > img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }

    & > aside {
      margin-top: 20px;

      /deep/ .ant-tabs-tab {
        margin-right: 0;
        border: none;
        background-color: #ffffff;
        color: black;
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
        font-size: 14px;
        color: var(--ThemeColor);
        font-weight: bold;
      }

      /deep/ .ant-tabs-nav {
        margin-top: -2px;
      }

      // .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      //   height:100%;
      //   top:0;
      //   margin-top:0;
      // }
      .card-container {
        .basicInfor {
          // background-color: #6982f3;
          margin-top: 20px;
          display: flex;

          .basicInfor_left {
            // width:710px;
            // width: 58%;
            width: 60%;
            height: auto;

            .img_big {
              width: 710px;
              // height:400px;
              background: #f2f2f2;
              margin-bottom: 10px;
            }
          }

          .basicInfor_right {
            // width: calc(42% - 60px);
            width: calc(40% - 40px);
            display: flex;
            flex-direction: column;
            margin-left: 40px;

            .follow-up {
              // margin-top: 56px;
              margin-top: 40px;
              margin-bottom: 20px;
              display: flex;
              // border:1px solid #f2f6fc;
              // padding: 20px;
              .title {
                width: 90px;
                font-weight: 700;
              }

              .msg {
                width: calc(100% - 90px);
                min-width: 200px;

                > div {
                  display: flex;
                  justify-content: space-between;
                }

                .describe {
                  display: flex;
                  flex-wrap: wrap;
                  // width: 400px;
                  overflow: hidden;
                  white-space: normal;
                  word-break: break-all;
                }

                h1 {
                  font-weight: 700;
                }
              }
            }
          }

          .basicInforImg {
            width: 139px;
            height: 137px;
          }

          .basicNew {
            .basicTelte {
              width: 100%;
              display: flex;
              flex-direction: column;
              // margin-top: 15px;
              .basicTelteTu {
                display: flex;
                flex-direction: row;
                position: relative;
                // top: -3px;
                width: 200px;
                height: 40px;
                margin: 10px 0;
                // background: #f6ffed;
                justify-content: space-around;
                align-items: center;
                // box-shadow: 1px 1px 3px #ccc;
                // -webkit-box-shadow: 1px 1px 3px #ccc;
                // border-radius:3px;
                // -webkit-border-radius:3px;
                .detail-t {
                  width: 40px;
                  height: 40px;
                  text-align: center;
                  vertical-align: middle;
                  line-height: 40px;
                  box-shadow: 1px 1px 3px #ccc;
                  -webkit-box-shadow: 1px 1px 3px #ccc;
                }

                .detail-t:first-child {
                  margin-left: 0;
                }
              }

              .house-basicInfoR-warpper {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;

                .shop_name_price_area {
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: column;
                  justify-content: space-between;
                  // width: 90%;
                  width: 100%;

                  .shop_name {
                    // font-size: 20px;
                    font-size: 24px;
                    font-weight: bold;
                    color: #222;
                  }
                }

                .basicTeltexi {
                  font-size: 24px;
                  margin-right: 50px;
                  font-weight: bold;
                  color: #222222;
                  line-height: 40px;
                  display: flex;
                  flex-direction: column;

                  .tag_house_status {
                    width: 50px;
                    text-align: center;
                    margin-bottom: 20px;
                  }
                }

                .price {
                  margin-bottom: 20px;

                  .priceInfor {
                    display: flex;
                    align-items: center;

                    .priceHousin {
                      // font-size: 16px;
                      font-size: 20px;
                      font-weight: bold;
                      color: #000;
                    }

                    .priceTag {
                      background: #2fba6c;
                      color: #fff;
                      height: 17px;
                      padding: 0 5px;
                      font-size: 12px;
                      line-height: 17px;
                      margin-top: 2px;
                      margin-left: 7px;
                    }

                    .price_transferFee {
                      margin-left: 30px;
                      font-size: 18px;
                      // font-size:14px;
                      color: #222;
                    }
                  }

                  .houseup {
                    font-size: 20px;
                    color: #222222;
                  }
                }

                .dish_tag_area_floor {
                  display: flex;
                  align-items: center;

                  .dish_tag {
                    .dish_type {
                      background: green;
                      color: #fff;
                      border-radius: 10px;
                      -webkit-border-radius: 10px;
                    }
                  }

                  .housArea {
                    margin-left: 10px;

                    .areaInfor {
                      font-weight: bolder;
                      color: #222;
                    }
                  }
                }

                // .dish_tag{
                //    .dish_type{
                //       background: green;
                //       color: #fff;
                //       border-radius: 10px;
                //       -webkit-border-radius: 10px;
                //    }
                //   }
                .house_special {
                  width: 100%;
                  margin: 20px 0 0 0;
                }
              }

              .list_info {
                width: 100%;
                display: flex;
                // flex-direction: column;
                flex-direction: row;
                flex-wrap: wrap;

                .item_info {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: row;
                  align-items: center;
                  color: #222;
                  line-height: 30px;
                  margin: 0;

                  .item_info_val {
                    margin: 0;
                    padding: 0;

                    p {
                      margin: 0;
                    }
                  }
                }
              }
            }

            .houseTag {
              margin: 10px 0px;
            }

            .houseInfor {
              display: flex;
              flex-direction: column;
              // margin-top: 13px;
              // margin-bottom: 20px;
              .address {
                margin-bottom: 20px;

                .housin {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }

                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }

              .housArea {
                margin-right: 20px;

                .areaInfor {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }

                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }
            }
          }

          .first-col {
            cursor: pointer;

            & > img {
              width: 200px;
              height: 200px;
              border-radius: 10px;
            }
          }

          /deep/ .ant-col-10 {
            margin-top: 28px;
          }

          .second-col {
            height: 100%;
            cursor: pointer;

            & > ul {
              list-style: none;

              & > li {
                &:nth-of-type(1) {
                  width: 280px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 20px;

                  & > span {
                    font-size: 14px;
                    color: black;
                    font-weight: bold;
                  }

                  & > img {
                    width: 18px;
                    height: 18px;
                    margin-top: 6px;
                  }
                }

                &:nth-of-type(2) {
                  margin-top: 20px;

                  & > span {
                    display: inline-block;
                    width: 46px;
                    height: 28px;
                    font-size: 12px;
                    border-radius: 5px;
                    line-height: 28px;
                    text-align: center;
                    margin-right: 10px;
                  }

                  & > .green {
                    border: 1px solid #7ac756;
                    color: #7ac756;
                    background-color: #eef8e8;
                  }

                  & > .orange {
                    border: 1px solid var(--ThemeColor);
                    color: var(--ThemeColor);
                    background-color: #fdf5e9;
                  }

                  & > .red {
                    border: 1px solid #f26161;
                    color: #f26161;
                    background-color: #feeeee;
                  }
                }

                &:nth-of-type(3) {
                  // width: calc(100% - 280px - 6%);
                  margin-top: 20px;
                  color: black;

                  p {
                    &:first-of-type {
                      margin-bottom: 0px;
                      font-weight: bold;
                      font-size: 14px;
                    }
                  }

                  .mid-span {
                    display: flex;
                    align-items: center;

                    & > p {
                      margin-bottom: 0px;
                    }

                    & > span {
                      width: 53px;
                      height: 17px;
                      background-color: #2fba6c;
                      color: white;
                      line-height: 17px;
                      text-align: center;
                    }
                  }
                }
              }
            }
          }

          .last-col {
            cursor: pointer;

            & > ul {
              width: 86%;
              list-style: none;
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              margin-left: 86px;

              & > li {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                & > span {
                  display: inline-block;
                  width: 70px;
                  height: 70px;
                  background-color: var(--ThemeColor);
                  border-radius: 50%;
                }
              }
            }
          }
        }

        /* .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
        }
        .swiper-button-next {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/right.png') center center no-repeat;
        }
        .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/left.png') center center no-repeat;
        }
        .swiperbox {
          position: initial;
        } */

        .lunbo {
          width: 100%;
          //height: 260px;
          margin-top: 40px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 50px;

          & > .lunbo-child {
            margin: 0 auto;
            width: 93%;
            height: 100%;
            background-color: white;
            flex-shrink: 1;
            overflow: hidden;
            display: flex;
            justify-content: space-between;

            & > img {
              height: 100%;
              // width: 400px;
              width: 100%;
              margin-right: 10px;
              flex-shrink: 1;
            }
          }
        }

        .botText {
          display: flex;
          width: 220px;
          justify-content: space-between;
          padding-top: 30px;
          padding-bottom: 10px;

          & > p {
            &:nth-of-type(1) {
              font-size: 14px;
              color: black;
            }

            &:nth-of-type(2) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }

            &:nth-of-type(3) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }
          }
        }

        .houseSiwper {
          margin-top: 15px;

          .ant-carousel /deep/ .slick-slide {
            text-align: center;
            height: 200px;
            line-height: 200px;
            background: #79d3df;
            overflow: hidden;
          }

          .ant-carousel /deep/ .custom-slick-arrow {
            width: 25px;
            height: 25px;
            font-size: 14px;
            color: #fff;
            background-color: rgba(31, 45, 61, 0.11);
            opacity: 0.3;
          }

          .ant-carousel /deep/ .custom-slick-arrow:before {
            display: none;
          }

          .ant-carousel /deep/ .custom-slick-arrow:hover {
            opacity: 0.5;
          }

          .ant-carousel /deep/ .slick-slide h3 {
            color: #fff;
          }
        }

        .remark {
          width: 100%;
          height: 200px;
          border: 2px solid #f2f6fc;
          border-radius: 3px;
          -webkit-border-radius: 3px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
        }

        .house_intro_remark {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-around;

          .textarea_info {
            width: 48%;
            height: auto;

            .title {
              color: #222;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
            }

            .con {
              width: 96%;
              height: 120px;
              padding: 10px 2%;
              line-height: 30px;
              // border:1px solid var(--ThemeColor);
              border-radius: 8px;
              -webkit-border-radius: 8px;
              overflow-x: hidden;
              overflow-y: auto;
              box-shadow: 1px 1px 3px var(--ThemeColor);
              -webkit-box-shadow: 1px 1px 3px var(--ThemeColor);
            }
          }
        }

        .bot-detail {
          margin: 40px 0 0 0px;
          width: 100%;
          border-top: 2px solid #f2f6fc;

          /deep/ .ant-col-12 {
            display: flex;
            align-items: center;
            padding-top: 20px;
            // padding-bottom: 20px;

            p {
              font-size: 16px;
              color: #222222;
              margin-right: 20px;
              font-weight: 700;
              display: inline-block;
              margin-bottom: 0;
            }

            span {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
              margin-right: 10px;
            }
          }

          .bot-detail-bot {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 40px;

            .bot-detail-left {
              width: 49.5%;
              // height: 734px;
              height: auto;
              padding-bottom: 30px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              display: flex;
              justify-content: center;

              .bot-detail-left-center {
                width: 91%;
                padding-top: 30px;

                & > ul {
                  // width: 80%;
                  list-style: none;
                  margin: 0 auto;
                  display: flex;
                  // justify-content: space-between;
                  // justify-content: space-around;
                  align-items: center;
                  // margin-left: 49px;
                  padding-left: 0px;

                  .show {
                    width: 70px;
                    height: 30px;
                    background-color: var(--ThemeColor);
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }

                  & > li {
                    width: 70px;
                    height: 30px;
                    background-color: #cccccc;
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }
                }

                .child-bot {
                  margin-top: 20px;

                  .row {
                    padding-bottom: 10px;
                    padding-top: 10px;
                    border-bottom: 1px solid #f2f6fc;
                    display: flex;

                    .col-one {
                      margin-right: 10px;
                    }

                    .col-two {
                      flex: 1;

                      .flex-warp {
                        word-break: break-all;
                      }
                    }

                    .col-three {
                      width: 140px;
                    }
                  }
                }
              }
            }

            .bot-detail-right {
              width: 49.5%;
              // padding: 30px 0 0 2px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              // margin-right: 41px;

              .right-center {
                img {
                  width: 64px;
                  height: 64px;
                  border-radius: 64px;
                  -webkit-border-radius: 64px;
                  // margin-top: 20px;
                  // margin-top: 8px;
                }

                width: 94%;
                margin: 0 auto;

                /deep/ .ant-row {
                  // margin-bottom: 30px;
                  border-bottom: 1px solid #f2f6fc;
                  padding-bottom: 15px;
                  padding-top: 15px;
                }

                /deep/ .ant-col-4 {
                  & > img {
                    width: 90px;
                    height: 90px;
                    border-radius: 100px;
                  }
                }

                /deep/ .ant-col-20 {
                  & > p {
                    &:nth-of-type(1) {
                      font-size: 14px;
                      color: black;
                      font-weight: bold;
                      margin-top: 14px;
                    }

                    &:nth-of-type(2) {
                      font-size: 14px;
                      color: black;

                      & > span {
                        font-size: 14px;
                        font-weight: normal;
                        color: #c2c1bf;
                        margin-left: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  & > #lookModel {
    /deep/ #lookUl {
      list-style: none;
      display: flex;
      justify-content: center;

      & > li {
        & > img {
          width: 200px;
          height: 200px;
          border-radius: 200px;
        }

        &:nth-of-type(2) {
          list-style: none;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  .uploads {
    /deep/ .ant-upload.ant-upload-select-picture-card {
      width: 150px;
      height: 150px;
    }

    .avatar-uploader > .ant-upload {
      width: 328px;
      height: 328px;
    }

    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }

  .state {
    width: 50px;
    height: 50px;
    background: #ccc;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    // margin-top: 15px;
    margin-top: 8px;
  }

  .editdept {
    display: flex;
    padding-left: 15px;
    justify-content: space-between;
  }

  .department {
    padding-top: 12px;
    font-size: 14px;
    color: black;
    font-weight: bold;
    margin-bottom: 10px;
    padding-left: 15px;
  }
}

.look {
  display: flex;

  .owner {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    line-height: 95px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-right: 10px;
  }

  p {
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    margin-left: 20px;
  }

  .msg {
    div {
      padding-top: 20px;
    }
  }
}

.Model {
  width: 200px;
  height: 200px;
  border: 1px solid #e8e8e8;
  position: absolute;
  z-index: 999;
  background: #fff;
  top: 89px;
  right: 0;

  #components-popover-demo-placement .ant-btn {
    width: 70px;
    text-align: center;
    padding: 0;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}

.gdicon {
  .Moeldtb {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }

  .Moeld {
    text-align: center;
    color: var(--ThemeColor);
  }

  .topcenter {
    position: fixed;
    top: 9%;
    left: 26%;
  }
}

.Img {
  display: flex;
}

.interview-textarea {
  margin-top: 20px;
  width: 100%;
  height: 90px;
  outline: none;
  border-radius: 10px;
  border-color: #f1f2f3;
  padding: 10px;
  margin-bottom: 20px;
  resize: none;
  overflow: hidden;
}
</style>

<style scoped>
.box {
  width: 100%;
  position: relative;
  background-color: #fff;
  /* padding-top: 40px; */
}

.swiper-container {
  position: relative;
}

.swiper-box {
  /* width: 960px; */
  width: 100%;
  margin: auto;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
  /* width: 82%; */
  width: 100%;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  /* opacity: 0.4; */
  opacity: 1;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

.swiper-slide {
  text-align: center;
  /* height: 480px; */
  height: 50vh;
  display: flex;
  transition: 300ms;
  /* transform: scale(0.6); */
  transform: scale(1);
  /* opacity: 0.3; */
  opacity: 1;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.swiper-slide-next {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
  z-index: 998 !important;
}

.swiper-slide-prev {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
}

.swiper-slide-active {
  opacity: 1;
  z-index: 999 !important;
}

.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
  --swiper-navigation-color: #999 !important;
  /* top: 330px; */
}

.gallery-thumbs .swiper-slide {
  height: 120px !important;
}

.gallery-thumbs .swiper-slide-active {
  border: 4px solid #006c95;
}

.swiper-thumbs-prev,
.swiper-thumbs-next {
  position: absolute;
  z-index: 99;
  top: 10px;
  width: 27px;
  height: 120px;
  background: rgba(0, 0, 0, 0.8);
}

.swiper-thumbs-next {
  left: 0px;
}

.swiper-thumbs-prev {
  right: 0px;
}

.bottom-box {
  width: 100%;
  height: 400px;
  position: relative;
  margin-top: 40px;
}

.bottom-b-img {
  width: 100%;
  height: 100%;
  position: absolute;
}

.bottom-b-color {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  background: rgba(0, 108, 149, 0.6);
  display: flex;
  align-items: center;
}

.bottom-img {
  width: 400px;
  height: 100px;
  margin: auto;
}

/* .swiper-slide[data-v-7292165a] {
  height: 370px;
} */
.btn_more {
  color: black;
  text-align: center;
  /* border-bottom:1px solid #f2f2f2; */
}

.btn_more:hover {
  color: var(--ThemeColor);
}

.swiper-show_video,
.swiper-show_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
